"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withdrawTemplatesError = exports.withdrawTemplateError = exports.subscribeToWithdrawalTickets = exports.submittingWithdraw = exports.requestWithdrawTickets = exports.receiveWithdrawWorkflowInfo = exports.receiveWithdrawTickets = exports.receiveWithdrawTicket = exports.receiveWithdrawTemplates = exports.receiveWithdrawTemplate = exports.receiveWithdrawFee = exports.getWithdrawTickets = exports.getWithdrawFee = exports.getAccountVerificationLevelConfig = exports.fetchingWithdrawTemplates = exports.fetchingWithdrawTemplate = exports.fetchProductWithdrawTemplates = exports.fetchProductWithdrawTemplate = exports.createWithdrawTicket = exports.cancelWithdrawTicket = exports.addWithdrawalTicket = exports.SUBMITTING_WITHDRAW = exports.RETAIL_FIAT_CONFIRM_WITHDRAW = exports.REQUEST_WITHDRAW_TICKETS = exports.RECEIVE_WITHDRAW_WORKFLOW_INFO = exports.RECEIVE_WITHDRAW_TICKETS = exports.RECEIVE_WITHDRAW_TICKET = exports.RECEIVE_WITHDRAW_TEMPLATE_ERROR = exports.RECEIVE_WITHDRAW_TEMPLATES_ERROR = exports.RECEIVE_WITHDRAW_TEMPLATES = exports.RECEIVE_WITHDRAW_TEMPLATE = exports.RECEIVE_WITHDRAW_FEE = exports.RECEIVE_VERIFICATION_LEVEL_CONFIGS = exports.FETCH_PRODUCT_WITHDRAW_TEMPLATES = exports.FETCH_PRODUCT_WITHDRAW_TEMPLATE = exports.ADD_WITHDRAWAL_TICKET = void 0;
var _apiActions = require("./apiActions");
var _withdrawSubscriptionService = _interopRequireDefault(require("../../services/subscriptions/withdrawSubscriptionService"));
var _snackbarActions = require("./snackbarActions");
var _sidePaneActions = require("./sidePaneActions");
var _errorTextFormatter = require("../../helpers/errorTextFormatter");
var _excluded = ["ProductId", "amount", "iconFileName", "ProductSymbol", "ProductFullName", "AccountProviderId"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var REQUEST_WITHDRAW_TICKETS = exports.REQUEST_WITHDRAW_TICKETS = 'REQUEST_WITHDRAW_TICKETS';
var FETCH_PRODUCT_WITHDRAW_TEMPLATES = exports.FETCH_PRODUCT_WITHDRAW_TEMPLATES = 'FETCH_PRODUCT_WITHDRAW_TEMPLATES';
var FETCH_PRODUCT_WITHDRAW_TEMPLATE = exports.FETCH_PRODUCT_WITHDRAW_TEMPLATE = 'FETCH_PRODUCT_WITHDRAW_TEMPLATE';
var RECEIVE_WITHDRAW_TEMPLATES = exports.RECEIVE_WITHDRAW_TEMPLATES = 'RECEIVE_WITHDRAW_TEMPLATES';
var RECEIVE_WITHDRAW_TEMPLATE = exports.RECEIVE_WITHDRAW_TEMPLATE = 'RECEIVE_WITHDRAW_TEMPLATE';
var RECEIVE_WITHDRAW_TEMPLATES_ERROR = exports.RECEIVE_WITHDRAW_TEMPLATES_ERROR = 'RECEIVE_WITHDRAW_TEMPLATE_ERROR';
var RECEIVE_WITHDRAW_TEMPLATE_ERROR = exports.RECEIVE_WITHDRAW_TEMPLATE_ERROR = 'RECEIVE_WITHDRAW_TEMPLATE_ERROR';
var SUBMITTING_WITHDRAW = exports.SUBMITTING_WITHDRAW = 'SUBMITTING_WITHDRAW';
var RECEIVE_WITHDRAW_TICKET = exports.RECEIVE_WITHDRAW_TICKET = 'RECEIVE_WITHDRAW_TICKET';
var RECEIVE_WITHDRAW_TICKETS = exports.RECEIVE_WITHDRAW_TICKETS = 'RECEIVE_WITHDRAW_TICKETS';
var RECEIVE_WITHDRAW_WORKFLOW_INFO = exports.RECEIVE_WITHDRAW_WORKFLOW_INFO = 'RECEIVE_WITHDRAW_WORKFLOW_INFO';
var RECEIVE_WITHDRAW_FEE = exports.RECEIVE_WITHDRAW_FEE = 'RECEIVE_WITHDRAW_FEE';
var RETAIL_FIAT_CONFIRM_WITHDRAW = exports.RETAIL_FIAT_CONFIRM_WITHDRAW = 'RETAIL_FIAT_CONFIRM_DEPOSIT';
var ADD_WITHDRAWAL_TICKET = exports.ADD_WITHDRAWAL_TICKET = 'ADD_WITHDRAWAL_TICKET';
var fetchProductWithdrawTemplates = exports.fetchProductWithdrawTemplates = function fetchProductWithdrawTemplates(productId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      var payload, data, _data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch(fetchingWithdrawTemplates);
            payload = {
              ProductId: productId,
              OMSId: getState().user.userInfo.OMSId,
              AccountId: getState().user.selectedAccountId
            };
            _context.prev = 2;
            _context.next = 5;
            return dispatch((0, _apiActions.callAPI)('GetWithdrawFormTemplateTypes', payload));
          case 5:
            data = _context.sent;
            if (!data.result) {
              _context.next = 12;
              break;
            }
            if (data.TemplateTypes.length) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", dispatch(withdrawTemplatesError('There are no providers configured for this product')));
          case 9:
            dispatch(receiveWithdrawTemplates(data.TemplateTypes));
            if (data.TemplateTypes.length === 1) {
              dispatch(fetchProductWithdrawTemplate(productId, data.TemplateTypes[0].AccountProviderId));
            }
            return _context.abrupt("return", true);
          case 12:
            return _context.abrupt("return", dispatch(withdrawTemplatesError(data.errormsg)));
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](2);
            _context.next = 19;
            return dispatch((0, _apiActions.callAPI)('GetWithdrawTemplateTypes', payload));
          case 19:
            _data = _context.sent;
            if (_data.result) {
              dispatch(fetchProductWithdrawTemplate(productId, _data.TemplateTypes[0]));
            }
            dispatch(withdrawTemplatesError(_data.errormsg));
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 15]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var fetchProductWithdrawTemplate = exports.fetchProductWithdrawTemplate = function fetchProductWithdrawTemplate(ProductId, AccountProviderId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var TemplateType, template, payload, data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch(fetchingWithdrawTemplate(ProductId, AccountProviderId));
            template = getState().withdraw.templateTypes.find(function (i) {
              return i.AccountProviderId === parseFloat(AccountProviderId);
            });
            if (template) {
              TemplateType = template.TemplateName;
            } else {
              TemplateType = getState().withdraw.template;
            }
            payload = _objectSpread({
              OMSId: getState().user.userInfo.OMSId,
              AccountId: getState().user.selectedAccountId,
              TemplateType: TemplateType,
              ProductId: ProductId,
              AccountProviderId: AccountProviderId
            }, options);
            _context2.next = 6;
            return dispatch((0, _apiActions.callAPI)('GetWithdrawTemplate', payload));
          case 6:
            data = _context2.sent;
            if (!(data.result && data.Template)) {
              _context2.next = 9;
              break;
            }
            return _context2.abrupt("return", dispatch(receiveWithdrawTemplate(data)));
          case 9:
            return _context2.abrupt("return", dispatch(withdrawTemplateError(data.errormsg)));
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var getTemplateFormPayloadByInfo = function getTemplateFormPayloadByInfo(infoRaw, template) {
  // New object based on template saved in state
  var result = Object.keys(template).reduce(function (acc, key) {
    if (infoRaw[key] !== undefined && infoRaw[key] !== null && infoRaw[key] !== '') {
      acc[key] = infoRaw[key];
    }
    return acc;
  }, {});
  return JSON.stringify(result);
};
var createWithdrawTicket = exports.createWithdrawTicket = function createWithdrawTicket(_ref3) {
  var ProductId = _ref3.ProductId,
    amount = _ref3.amount,
    iconFileName = _ref3.iconFileName,
    ProductSymbol = _ref3.ProductSymbol,
    ProductFullName = _ref3.ProductFullName,
    AccountProviderId = _ref3.AccountProviderId,
    info = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var OMSId, AccountId, templateForm, accountProviderId, templateTypeObj, payload, withdrawStatus, workflowDetail;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            dispatch(submittingWithdraw);
            OMSId = getState().user.userInfo.OMSId;
            AccountId = getState().user.selectedAccountId;
            templateForm = info.TemplateForm || info;
            accountProviderId = AccountProviderId || getState().withdraw.AccountProviderId;
            templateTypeObj = getState().withdraw.templateTypes.find(function (template) {
              return template.AccountProviderId === parseInt(accountProviderId);
            }); // Since undefined is not serializable we default every prop to an empty string to avoid missing fields
            Object.keys(templateForm).forEach(function (prop) {
              return templateForm[prop] = templateForm[prop] || '';
            });
            payload = {
              OMSId: OMSId,
              AccountId: AccountId,
              ProductId: +ProductId,
              Amount: info.Amount,
              TemplateForm: getTemplateFormPayloadByInfo(templateForm, getState().withdraw.template),
              TemplateType: templateTypeObj.TemplateName || getState().withdraw.template.TemplateType,
              AccountProviderId: +templateTypeObj.AccountProviderId
            };
            _context3.next = 10;
            return dispatch((0, _apiActions.callAPI)('CreateWithdrawTicket', payload));
          case 10:
            withdrawStatus = _context3.sent;
            if (!(withdrawStatus.result === false)) {
              _context3.next = 13;
              break;
            }
            return _context3.abrupt("return", dispatch((0, _snackbarActions.showSnack)({
              id: 'withdrawRejectSnack',
              text: (0, _errorTextFormatter.formatErrorText)(withdrawStatus),
              type: 'warning'
            })));
          case 13:
            _context3.prev = 13;
            workflowDetail = JSON.parse(withdrawStatus.detail);
            if (!(_typeof(workflowDetail) === 'object' && workflowDetail.ReplyObject && workflowDetail.ReplyObject !== '0')) {
              _context3.next = 17;
              break;
            }
            return _context3.abrupt("return", dispatch(receiveWithdrawWorkflowInfo(workflowDetail)));
          case 17:
            _context3.next = 21;
            break;
          case 19:
            _context3.prev = 19;
            _context3.t0 = _context3["catch"](13);
          case 21:
            dispatch((0, _sidePaneActions.closeWithdrawSidePane)());
            dispatch((0, _snackbarActions.showSnack)({
              id: 'withdrawSuccessSnack',
              // t("Your withdraw has been successfully added, please check email for instructions.")
              text: 'Your withdraw has been successfully added, please check email for instructions.',
              type: 'success'
            }));
            dispatch(receiveWithdrawTicket(withdrawStatus));
            return _context3.abrupt("return", dispatch(getWithdrawTickets(AccountId, OMSId)));
          case 25:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[13, 19]]);
    }));
    return function (_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var getWithdrawFee = exports.getWithdrawFee = function getWithdrawFee(ProductId, Amount, AccountProviderId) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var OMSId, AccountId, payload, withdrawFee;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            AccountId = getState().user.selectedAccountId;
            payload = {
              OMSId: OMSId,
              ProductId: ProductId,
              AccountId: AccountId,
              AccountProviderId: AccountProviderId,
              Amount: Amount
            };
            _context4.prev = 3;
            if (payload.AccountProviderId) {
              payload.AccountProviderId = parseInt(payload.AccountProviderId);
            }
            _context4.next = 7;
            return dispatch((0, _apiActions.callAPI)('GetWithdrawFee', payload));
          case 7:
            withdrawFee = _context4.sent;
            _context4.next = 13;
            break;
          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](3);
            console.error(_context4.t0);
          case 13:
            if (!(withdrawFee && withdrawFee.result === false)) {
              _context4.next = 15;
              break;
            }
            return _context4.abrupt("return", dispatch((0, _snackbarActions.showSnack)({
              id: 'withdrawRejectSnack',
              text: (0, _errorTextFormatter.formatErrorText)(withdrawFee),
              type: 'warning'
            })));
          case 15:
            dispatch(receiveWithdrawFee(withdrawFee));
          case 16:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[3, 10]]);
    }));
    return function (_x7, _x8) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var cancelWithdrawTicket = exports.cancelWithdrawTicket = function cancelWithdrawTicket(_ref6) {
  var RequestCode = _ref6.RequestCode;
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch, getState) {
      var _getState$user$userIn, OMSId, UserId, AccountId, payload, withdrawStatus;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _getState$user$userIn = getState().user.userInfo, OMSId = _getState$user$userIn.OMSId, UserId = _getState$user$userIn.UserId;
            AccountId = getState().user.selectedAccountId;
            payload = {
              OMSId: OMSId,
              UserId: UserId,
              AccountId: AccountId,
              RequestCode: RequestCode
            };
            _context5.next = 5;
            return dispatch((0, _apiActions.callAPI)('CancelWithdraw', payload));
          case 5:
            withdrawStatus = _context5.sent;
            if (!(withdrawStatus.result === false)) {
              _context5.next = 8;
              break;
            }
            return _context5.abrupt("return", dispatch((0, _snackbarActions.showSnack)({
              id: 'cancelWithdrawSnack',
              text: (0, _errorTextFormatter.formatErrorText)(withdrawStatus),
              type: 'warning'
            })));
          case 8:
            // t('Your withdraw has been successfully canceled')
            dispatch((0, _snackbarActions.showSnack)({
              id: 'cancelWithdrawSuccessSnack',
              text: 'Your withdraw has been successfully canceled',
              type: 'success'
            }));
            dispatch(getWithdrawTickets(AccountId, OMSId));
          case 10:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x9, _x10) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var subscribeToWithdrawalTickets = exports.subscribeToWithdrawalTickets = function subscribeToWithdrawalTickets() {
  return function (dispatch) {
    _withdrawSubscriptionService["default"].subscribe(function (updates) {
      dispatch(addWithdrawalTicket(updates));
    });
  };
};
var addWithdrawalTicket = exports.addWithdrawalTicket = function addWithdrawalTicket(payload) {
  return {
    type: ADD_WITHDRAWAL_TICKET,
    payload: payload
  };
};
var fetchingWithdrawTemplates = exports.fetchingWithdrawTemplates = {
  type: FETCH_PRODUCT_WITHDRAW_TEMPLATES
};
var fetchingWithdrawTemplate = exports.fetchingWithdrawTemplate = function fetchingWithdrawTemplate(ProductId, AccountProviderId) {
  return {
    type: FETCH_PRODUCT_WITHDRAW_TEMPLATE,
    payload: {
      ProductId: ProductId,
      AccountProviderId: AccountProviderId
    }
  };
};
var receiveWithdrawTemplates = exports.receiveWithdrawTemplates = function receiveWithdrawTemplates(payload) {
  return {
    type: RECEIVE_WITHDRAW_TEMPLATES,
    payload: payload
  };
};
var receiveWithdrawTemplate = exports.receiveWithdrawTemplate = function receiveWithdrawTemplate(payload) {
  return {
    type: RECEIVE_WITHDRAW_TEMPLATE,
    payload: payload
  };
};
var withdrawTemplatesError = exports.withdrawTemplatesError = function withdrawTemplatesError(payload) {
  return {
    type: RECEIVE_WITHDRAW_TEMPLATES_ERROR,
    payload: payload
  };
};
var withdrawTemplateError = exports.withdrawTemplateError = function withdrawTemplateError(payload) {
  return {
    type: RECEIVE_WITHDRAW_TEMPLATE_ERROR,
    payload: payload
  };
};
var submittingWithdraw = exports.submittingWithdraw = {
  type: SUBMITTING_WITHDRAW
};
var receiveWithdrawTicket = exports.receiveWithdrawTicket = function receiveWithdrawTicket(payload) {
  return {
    type: RECEIVE_WITHDRAW_TICKET,
    payload: payload
  };
};
var receiveWithdrawFee = exports.receiveWithdrawFee = function receiveWithdrawFee(payload) {
  return {
    type: RECEIVE_WITHDRAW_FEE,
    payload: payload
  };
};
var requestWithdrawTickets = exports.requestWithdrawTickets = function requestWithdrawTickets(payload) {
  return {
    type: REQUEST_WITHDRAW_TICKETS,
    payload: payload
  };
};
var receiveWithdrawTickets = exports.receiveWithdrawTickets = function receiveWithdrawTickets(payload) {
  return {
    type: RECEIVE_WITHDRAW_TICKETS,
    payload: payload
  };
};
var receiveWithdrawWorkflowInfo = exports.receiveWithdrawWorkflowInfo = function receiveWithdrawWorkflowInfo(payload) {
  return {
    type: RECEIVE_WITHDRAW_WORKFLOW_INFO,
    payload: payload
  };
};
var getWithdrawTickets = exports.getWithdrawTickets = function getWithdrawTickets(AccountId, OMSId) {
  var StartIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(dispatch) {
      var withdrawTickets;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            dispatch(requestWithdrawTickets({
              StartIndex: StartIndex
            }));
            _context6.next = 3;
            return dispatch((0, _apiActions.callAPI)('GetWithdrawTickets', {
              AccountId: AccountId,
              OMSId: OMSId,
              StartIndex: StartIndex
            }));
          case 3:
            withdrawTickets = _context6.sent;
            dispatch(receiveWithdrawTickets(withdrawTickets));
          case 5:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x11) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var RECEIVE_VERIFICATION_LEVEL_CONFIGS = exports.RECEIVE_VERIFICATION_LEVEL_CONFIGS = 'RECEIVE_VERIFICATION_LEVEL_CONFIGS';
var receiveVerificationLevelConfigs = function receiveVerificationLevelConfigs(payload) {
  return {
    type: RECEIVE_VERIFICATION_LEVEL_CONFIGS,
    payload: payload
  };
};
var getAccountVerificationLevelConfig = exports.getAccountVerificationLevelConfig = function getAccountVerificationLevelConfig() {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch, getState) {
      var state;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            state = getState();
            _context7.next = 3;
            return dispatch((0, _apiActions.callAPI)('GetVerificationLevelConfig', {
              OMSId: state.user.userInfo.OMSId,
              AccountId: state.user.selectedAccountId
            })).then(function (res) {
              return dispatch(receiveVerificationLevelConfigs(res));
            });
          case 3:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x12, _x13) {
      return _ref9.apply(this, arguments);
    };
  }();
};